import { render, staticRenderFns } from "./ModattaStepInteractionTag.vue?vue&type=template&id=91d7bb22"
import script from "./ModattaStepInteractionTag.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports